import React from "react";
import ReactDOM from "react-dom";
import App from './App'
import memory from './utils/memory'
import storage from './utils/storage'

memory.user_info = storage.getInfo('user_info')
memory.setting   = storage.getInfo('setting')

ReactDOM.render(<App />, document.getElementById("root"));